"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @module BryxApi */
var cerealParse_1 = require("../../cerealParse");
var spoonClient_1 = require("../../spoonClient");
var TestHttpClient_1 = require("../TestHttpClient");
var models_1 = require("../../models");
/*type ServerType = 'dev' | 'staging' | 'prod' | 'test';
interface Config {
  serverType: ServerType;
  version: string;
}*/
/**
 * Base class to make API class.
 * @todo Redo all variables to be correct and comment.
 */
var BaseApi = /** @class */ (function () {
    /**
     * Creates base api object according to config.
     * @TODO Get API key from local storage.
     * @param config
     * @param local
     */
    function BaseApi(config, local, testResponses) {
        // constructor(config: Config) {
        var _this = this;
        if (config === void 0) { config = { baseUrl: 'localhost', serverType: 'dev', site: 'test', version: '0', serverLocale: 'us' }; }
        this.brandUrl = 'https://bryx.com';
        if (config.serverLocale == null) {
            config.serverLocale = 'us';
        }
        this.urlSuffix = config.serverLocale == 'us' ? 'com' : 'ca';
        this.downloadUrl = "https://downloads.bryx." + this.urlSuffix + "/ua";
        this.platform = config.site;
        this.siteName = config.site;
        this.version = config.version;
        if (config.serverType == 'prod' || config.serverType == 'k8s') {
            this.baseUrlPrefix = '';
            this.urlPrefix = "";
            this.baseHost = config.baseUrl;
            this.baseUrl = "https://" + this.baseHost;
            this.apiRoot = this.baseUrl + "/api/2.2";
            this.joinUrl = this.baseUrl + "/signup";
            this.manageUrl = "https://manage." + this.baseHost;
            this.appUrl = "https://app." + this.baseHost;
        }
        else {
            // This is just for backwards compat for now only, really applies to dev:
            this.baseUrlPrefix = config.serverType + ".";
            this.urlPrefix = config.serverType + "-";
            // This is used for the UI link building, so for dev it's strange because of our DNS.
            this.baseHost = "bryx911." + this.urlSuffix;
            this.baseUrl = "https://" + this.baseUrlPrefix + "bryx911." + this.urlSuffix;
            this.apiRoot = this.baseUrl + "/api/2.2";
            this.joinUrl = this.baseUrl + "/signup";
            this.manageUrl = "https://" + this.urlPrefix + "manage.bryx911." + this.urlSuffix;
            this.appUrl = "https://" + this.urlPrefix + "app.bryx911." + this.urlSuffix;
        }
        if (local) {
            this.local = local;
        }
        this.http = (function () {
            var httpClientConfig = {
                baseUrl: _this.apiRoot,
                transformRequest: function (request) {
                    var headers = request.headers || {};
                    // const currentApiKey = getCurrApiKey(); // BryxLocal.getApiKey();
                    var currentApiKey = local ? local.apiKey : null;
                    if (currentApiKey != null) {
                        headers['X-API-KEY'] = currentApiKey;
                    }
                    if (request.body != null) {
                        headers['content-type'] = 'application/json';
                    }
                    request.headers = headers;
                    return request;
                },
            };
            if (testResponses) {
                if (local) {
                    return new TestHttpClient_1.default(httpClientConfig, testResponses, _this.local);
                }
                else {
                    return new TestHttpClient_1.default(httpClientConfig, testResponses);
                }
            }
            return new spoonClient_1.HttpClient(httpClientConfig);
        })();
    }
    /**
     * Formats successful API result.
     * @param value
     * @return Successful API result.
     */
    BaseApi.prototype.apiSuccess = function (value) {
        return { success: true, value: value };
    };
    /**
     * Formats failed API result.
     * @param message
     * @param debugMessage
     * @return Failed API result.
     */
    BaseApi.prototype.apiFailure = function (message, debugMessage) {
        return {
            success: false,
            // Use '$t()' for i18next nesting [https://www.i18next.com/translation-function/nesting]
            message: message || '$t(general.genericError)',
            debugMessage: debugMessage,
        };
    };
    /**
     * Null parser function.
     * @param o
     * @return Null parse result
     */
    BaseApi.prototype.nullParser = function (o) {
        return cerealParse_1.ParseUtils.parseSuccess(null);
    };
    /**
     * Formats API array result from parser.
     * @param response
     * @param parseFunction
     * @param failBehavior
     * @return API array result from parser.
     */
    BaseApi.prototype.apiArrayResultFromParse = function (response, parseFunction, failBehavior) {
        if (response.status == spoonClient_1.ResponseStatus.Success) {
            var itemsObject = { items: response.responseJson };
            return this.apiSuccess(cerealParse_1.ParseUtils.getArrayOfSubobjects(itemsObject, 'items', parseFunction, failBehavior));
        }
        else {
            return this.apiFailureWithResponse(response);
        }
    };
    /**
     * Formats API result from parser.
     * @param response
     * @param parseFunction
     * @return API result from parser.
     */
    BaseApi.prototype.apiResultFromParse = function (response, parseFunction) {
        if (response.status == spoonClient_1.ResponseStatus.Success) {
            var parseResult = parseFunction(response.responseJson);
            if (parseResult.success) {
                return this.apiSuccess(parseResult.value);
            }
            else {
                return this.apiFailure(parseResult.justification, parseResult.justification);
            }
        }
        else {
            return this.apiFailureWithResponse(response);
        }
    };
    /**
     * Formats API result from parser as string.
     * @param response
     * @return API result from parser as string.
     */
    BaseApi.prototype.apiStringResult = function (response) {
        if (response.status == spoonClient_1.ResponseStatus.Success && response.responseText != null) {
            return this.apiSuccess(response.responseText);
        }
        else {
            return this.apiFailureWithResponse(response);
        }
    };
    /**
     * Formats failed API result with response.
     * @param response
     * @return Failed API result with response.
     */
    BaseApi.prototype.apiFailureWithResponse = function (response) {
        if (response.status == spoonClient_1.ResponseStatus.ConnectionFailure) {
            return this.apiFailure('general.connectionFailure', 'Connection failure');
        }
        var errorResult = models_1.ApiError.parse(response.responseJson);
        if (errorResult.success) {
            return this.apiFailure(errorResult.value.message, errorResult.value.realCause || errorResult.value.message);
        }
        else {
            return this.apiFailure(null, errorResult.justification);
        }
    };
    /**
     * Call a function asynchronously.
     * @param funcName
     * @param args
     * @return Promise that resolves function.
     */
    BaseApi.prototype.callAsync = function (funcName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var func;
            return __generator(this, function (_a) {
                func = this[funcName].bind(this);
                if (typeof func !== 'function') {
                    throw new Error(funcName + " is not a function.");
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        func.apply(void 0, __spreadArrays(args, [function (data) {
                                resolve(data);
                            }]));
                    })];
            });
        });
    };
    return BaseApi;
}());
exports.default = BaseApi;
//# sourceMappingURL=BaseApi.js.map